import { domain } from 'modules/data';
import { useMemo } from 'react';
import { findDocumentFieldState } from 'shared/helpers';

export const useNetSuiteItemReceiptFieldSettings = (documentFields: domain.DocumentField[] | undefined) =>
    useMemo(
        () => ({
            currency: findDocumentFieldState(documentFields, 'Currency'),
            memo: findDocumentFieldState(documentFields, 'Memo'),
            exchangeRate: findDocumentFieldState(documentFields, 'OriginalExchangeRate'),
            reference: findDocumentFieldState(documentFields, 'Reference'),
            transactionDate: findDocumentFieldState(documentFields, 'TransactionDate'),
            vendor: findDocumentFieldState(documentFields, 'Vendor'),
            postingPeriod: findDocumentFieldState(documentFields, 'PostingPeriod'),
            purchaseOrder: findDocumentFieldState(documentFields, 'PurchaseOrder'),
        }),
        [documentFields]
    );
